<form [formGroup]="myFormGroup">
    <div *ngFor="let row of data" class="input_line">
        <div *ngIf="row.label && row.type !== 'checkbox'" class="name">
            <span [innerHTML]="row.label"></span>
        </div>
        <div class="input">
            <div *ngIf="row.type === 'select'">
                <app-component-default-select (selectedVal)="selectedValue(row.formControlName, $event)"
                                              [default_select]="row.formState"
                                              [row]="row.data">
                </app-component-default-select>
            </div>
            <input *ngIf="row.type === 'input'" formControlName="{{row.formControlName}}"
                   placeholder="{{row.placeholder}}"
                   type="text">
            <div *ngIf="row.type === 'checkbox'" class="checkbox mt-2 mb-2">
                <label>
                    <input formControlName="{{row.formControlName}}" type="checkbox">
                    <span>{{ row.label }}</span>
                </label>
            </div>
            <textarea *ngIf="row.type === 'textarea'"
                      cols="20" formControlName="{{row.formControlName}}" rows="5"></textarea>
            <app-component-date-time-picker (pickedDate)="selectedValue(row.formControlName, $event)"
                                            *ngIf="row.type === 'datetime'"
                                            [stringify]="true">
            </app-component-date-time-picker>
            <app-component-input-file (file)="onFileChange(row.formControlName, $event)"
                                      *ngIf="row.type === 'file'">
            </app-component-input-file>
            <app-component-users-multiselect
                    (value)="usersHandler({name: row.formControlName, data: $event})"
                    *ngIf="row.type === 'user-select'"
                    [onlyCrypto]="row.observeVal"
                    [sendObject]="true"
                    [typeSelect]="row.limit==1 ? 'one' : 'multi'">
            </app-component-users-multiselect>
            <app-component-users-multiselect
                    (value)="selectedValue(row.formControlName, $event)"
                    *ngIf="row.type === 'user-select-email'"
                    [onlyCrypto]="row.observeVal"
                    [sendEmail]="true"
                    [typeSelect]="row.limit==1 ? 'one' : 'multi'">
            </app-component-users-multiselect>
            <app-component-search-collection (data)="selectedValue(row.formControlName, $event)"
                                             *ngIf="row.type === 'search-collection'">
            </app-component-search-collection>
            <app-component-search-query (data)="selectedValue(row.formControlName, $event)"
                                        *ngIf="row.type === 'search-query'">
            </app-component-search-query>
            <app-component-departments-multiselect (value)="selectedValue(row.formControlName, $event)"
                                                   *ngIf="row.type === 'departments-multiselect'"
                                                   [limit]="row.limit || null">
            </app-component-departments-multiselect>
        </div>
        <app-component-couple-users-multiselect *ngIf="row.type === 'couple-users-select'"
                                                [formData]="row.data"></app-component-couple-users-multiselect>
    </div>
</form>
